import { reactive } from "@vue/composition-api";
 
export const dynamicFormData =  reactive( {data:{}} )